export type VideoWalkthrough = {
  id: string
  title: string
  description: string
  src: string
}

export const videoWalkthroughs: VideoWalkthrough[] = [
  {
    id: 'risk-insights',
    title: 'Introduction to Risk Insights',
    description:
      'See how Risk Insights gives you a complete view of your customers’ financial health — credit scores, suggested limits and real-time alerts when their circumstances change.',
    src: 'https://cdn.magicpatterns.com/uploads/uaNKdHfim9xLz8MtCzjz3x/1_introduction_to_risk_insights_v1 (1080p).mp4',
  },
  {
    id: 'credit-control',
    title: 'Introduction to Credit Control',
    description:
      'A walkthrough of the credit control tools — automated invoice chasing, sending schedules and customisable templates that get your invoices paid without manual chasing.',
    src: 'https://cdn.magicpatterns.com/uploads/dRsjHs6MEaNBQGALJZLfoE/2_introduction_to_credit_control_v1 (1080p).mp4',
  },
  {
    id: 'invoice-finance',
    title: 'Introduction to Invoice Finance',
    description:
      'How selective invoice finance works in practice — drawing funds against specific unpaid invoices to close a cash-flow gap, without committing your whole sales ledger.',
    src: 'https://cdn.magicpatterns.com/uploads/3FNe8pRs4BzM5EAugFEo2M/3_introduction_to_invoice_finance_v1 (1080p).mp4',
  },
  {
    id: 'onboarding',
    title: 'Introduction to Onboarding',
    description:
      'What to expect when you join — connecting your accounting software, completing your taskboard and getting your credit control running from day one.',
    src: 'https://cdn.magicpatterns.com/uploads/ttG1dfVdE1YWwwhwgM3ozP/4_introduction_to_onboarding_v1 (1080p).mp4',
  },
]
